import React, { useEffect, useState } from "react";
import { Layout, Menu, theme } from "antd";
import { Grid } from "@mui/material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useSetRecoilState } from "recoil";
import { orgID } from "../store/gloabalState";

const { Sider } = Layout;

const SideTabs = () => {
  let location = useLocation();
  const [currentMenuItem, setCurrentMenuItem] = useState("/");
  const [notOps, setNotOps] = useState(false)
  const setOrgId = useSetRecoilState(orgID)

  useEffect(() => {
    setCurrentMenuItem(location.pathname);
  }, [location, currentMenuItem]);

  useEffect(() => {
    let userInfo = Cookies.get("userInfo");
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      if (userInfo.userType === "BD" || userInfo.userType === "AM" || userInfo.userType === "BD_CHECKER") {
        setNotOps(true)
      }
    }
  }, [])

  return (
    <Grid
      item
      className="sidetabs"
      sx={{ padding: "1rem 0 !important", zIndex: 99 }}
    >
      <Sider trigger={null} style={{}}>
        <div className="logo" />
        {
          notOps ?
            <Menu
              theme="dark"
              mode="inline"
              defaultSelectedKeys={["/"]}
              selectedKeys={[currentMenuItem]}
            >
              <Menu.Item key={"/"}>
                <NavLink to={"/"}>Home</NavLink>
              </Menu.Item>
              <Menu.SubMenu title={"Organisation"} key={"Organisation"}>
                <Menu.Item key={"/orgs"}>
                  <NavLink to={"/orgs"}>View organisation</NavLink>
                </Menu.Item>
                <Menu.Item key={"/leads"}>
                  <NavLink to={"/leads"}>Leads</NavLink>
                </Menu.Item>
                <Menu.Item key={"/onboardorg"}>
                  <NavLink to={"/onboardorg"} onClick={() => {
                    setTimeout(() => {
                      localStorage.removeItem("orgId");
                      setOrgId("");
                      Cookies.remove('products');
                      Cookies.remove('userId');
                      localStorage.removeItem('CompanyType')
                    }, 100)
                  }}>Create Org</NavLink>
                </Menu.Item>
              </Menu.SubMenu>
            </Menu> :
            <Menu
              theme="dark"
              mode="inline"
              defaultSelectedKeys={["/"]}
              selectedKeys={[currentMenuItem]}
            >
              <Menu.Item key={"/"}>
                <NavLink to={"/"}>Home</NavLink>
              </Menu.Item>
              <Menu.Item key={"/alltransactions"}>
                <NavLink to={"/alltransactions"}>Outward transactions</NavLink>
              </Menu.Item>
              <Menu.Item key={"/inwardtransactions"}>
                <NavLink to={"/inwardtransactions"}>Inward transactions</NavLink>
              </Menu.Item>
              <Menu.Item key={"/createtransaction"}>
                <NavLink to={"/createtransaction"}>Create transaction</NavLink>
              </Menu.Item>
              <Menu.SubMenu title={"Organisation"} key={"Organisation"}>
                <Menu.Item key={"/orgs"}>
                  <NavLink to={"/orgs"}>View organisation</NavLink>
                </Menu.Item>
                {/* <Menu.Item key={"/addorg"}>
             <NavLink to={"/addorg"}>Create Organisation</NavLink>
           </Menu.Item> */}
                <Menu.Item key={"/adduser"}>
                  <NavLink to={"/adduser"}>Users</NavLink>
                </Menu.Item>
                {/* <Menu.Item key={"/signdocs"}>
             <NavLink to={"/signdocs"}>Signup Docs</NavLink>
           </Menu.Item> */}
                <Menu.Item key={"/leads"}>
                  <NavLink to={"/leads"}>Leads</NavLink>
                </Menu.Item>
                <Menu.Item key={"/onboardorg"}>
                  <NavLink to={"/onboardorg"} onClick={() => {
                    setTimeout(() => {
                      localStorage.removeItem("orgId");
                      setOrgId("");
                      Cookies.remove('products');
                      Cookies.remove('userId');
                      localStorage.removeItem('CompanyType')
                    }, 100)
                  }}>Create Org</NavLink>
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu title={"Vendors"} key={"Vendors"}>
                <Menu.Item key={"/addvendor"}>
                  <NavLink to={"/addvendor"}>Create Vendors</NavLink>
                </Menu.Item>
                <Menu.Item key={"/viewvendor"}>
                  <NavLink to={"/viewvendor"}>Edit Vendors</NavLink>
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu
                title={"Chartered Accountants"}
                key={"CharteredAccountants"}
              >
                <Menu.Item key={"/addcafirm"}>
                  <NavLink to={"/addcafirm"}>Create CA firm</NavLink>
                </Menu.Item>
                <Menu.Item key={"/addca"}>
                  <NavLink to={"/addca"}>Add CA</NavLink>
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu title={"Banks"} key={"Banks"}>
                <Menu.Item key={"/addbank"}>
                  <NavLink to={"/addbank"}>Setup Bank</NavLink>
                </Menu.Item>
                <Menu.Item key={"/viewbank"}>
                  <NavLink to={"/viewbank"}>View Bank</NavLink>
                </Menu.Item>
                <Menu.Item key={"/addbankuser"}>
                  <NavLink to={"/addbankuser"}>Create User</NavLink>
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu title={"Billings"} key={"Billings"}>
                <Menu.Item key={"/cabillings"}>
                  <NavLink to={"/cabillings"}>15CB/CA Billings</NavLink>
                </Menu.Item>
                {/* <Menu.Item key={"/traxbillings"}>
             <NavLink to={"/traxbillings"}>Transaction Billings</NavLink>
           </Menu.Item> */}
              </Menu.SubMenu>
            </Menu>
        }

      </Sider>
    </Grid>
  );
};
export default SideTabs;
